import { render, staticRenderFns } from "./mo-select-wrapper.html?vue&type=template&id=07796de4&external"
import script from "./mo-select-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-select-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports